<template>
  <el-dialog
    :title="$t('chainSupplier.purchaseOrder')"
    :visible.sync="dialogVisible"
    width="80%"
    :close-on-click-modal="false"
  >
    <el-form label-width="120px">
      <el-form-item :label="$t('chainSupplier.productName') + '：'">
        <span>{{ addChainProductInfo.prodName }}</span>
      </el-form-item>

      <el-form-item :label="$t('chainSupplier.unit') + '：'">
        <span>{{ addChainProductInfo.unitName }}</span>
      </el-form-item>

      <el-form-item :label="$t('chainSupplier.productCover') + '：'">
        <el-image
          style="width: 50px; height: 50px"
          :src="addChainProductInfo.coverPhoto"
          :preview-src-list="[addChainProductInfo.coverPhoto]"
        >
          <div slot="error" class="image-slot">
            <img src="/img/noPhoto.jpg" style="width: 50px; height: 50px">
          </div>
        </el-image>
      </el-form-item>

      <el-card>
        <div slot="header" class="flex justify-between">
          <span>{{ $t('chainSupplier.orderSpecQuantity') }}</span>
        </div>
        <el-table :data="addChainProductInfo.chainProductValueDtos" border>
          <el-table-column prop="specName" :label="$t('chainSupplier.specName')" align="center" />
          <el-table-column prop="specValue" :label="$t('chainSupplier.specValue')" align="center" />
          <el-table-column prop="price" :label="$t('chainSupplier.price')" align="center" />
          <el-table-column :label="$t('chainSupplier.purchaseQuantity')" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.count"
                class="quantity-input"
                type="number"
                min="1"
              />
            </template>
          </el-table-column>
          <el-table-column :label="$t('chainSupplier.pricingStrategy')" align="center">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.ruleId"
                style="width: 100%"
                :placeholder="$t('chainSupplier.selectPricingStrategy')"
              >
                <el-option
                  v-for="item in productPriceRules"
                  :key="item.ruleId"
                  :label="item.ruleName"
                  :value="item.ruleId"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label="$t('chainSupplier.remark')" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" />
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <div style="margin-top: 20px; text-align: right">
        <el-button @click="dialogVisible = false">
          {{ $t('common.cancel') }}
        </el-button>
        <el-button type="primary" @click="saveSupplierOrder">
          {{ $t('common.save') }}
        </el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { saveChainInoutOrder, listProductPriceRule, queryProductDeatil } from '@/api/goods/chainSupplierApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddChainSupplierProduct',
  data() {
    return {
      dialogVisible: false,
      addChainProductInfo: {
        productId: '',
        catalogId: '',
        prodName: '',
        unitName: '',
        coverPhoto: '',
        chainProductValueDtos: [],
        shopId: '',
        groupId: ''
      },
      productPriceRules: [],
      chainProductDetail: {}
    }
  },
  methods: {
    open(product) {
      this.resetForm()
      Object.assign(this.addChainProductInfo, product)
      this.addChainProductInfo.shopId = getShopId()
      this.listProductPriceRules()
      this.listProductDetail()
      this.dialogVisible = true
    },
    listProductDetail() {
      queryProductDeatil({
        productId: this.addChainProductInfo.productId,
        page: 1,
        row: 50,
        csId: this.addChainProductInfo.csId
      }).then(response => {
        this.chainProductDetail = response.data
        console.log(this.chainProductDetail)
      })
    },
    listProductPriceRules() {
      listProductPriceRule({
        page: 1,
        row: 100,
        shopId: getShopId()
      }).then(response => {
        this.productPriceRules = response.data
      })
    },
    saveSupplierOrder() {
      saveChainInoutOrder(this.addChainProductInfo).then(response => {
        if (response.code === 0) {
          this.$message.success(this.$t('chainSupplier.purchaseSuccess'))
          this.dialogVisible = false
          this.resetForm()
        } else {
          this.$message.error(response.msg)
        }
      }).catch(error => {
        this.$message.error(error)
      })
    },
    resetForm() {
      this.addChainProductInfo = {
        productId: '',
        catalogId: '',
        prodName: '',
        unitName: '',
        coverPhoto: '',
        chainProductValueDtos: [],
        shopId: '',
        groupId: ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.quantity-input {
  width: 80px;
}
</style>